import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { getFaq } from "../httpService";
import { getSnapshotValue, hasSnapshotValue } from "../snapshot.js";
import { UserContext } from "./UserContext";

const FaqContext = createContext({ faqItems: [], loading: true, error: null });

const FaqContextProvider = (props) => {
  const [faqItems, setFaqItems] = useState(() => getSnapshotValue("faq", []));
  const [loading, setLoading] = useState(() => !hasSnapshotValue("faq"));
  const [error, setError] = useState(null);
  const { locale } = useContext(UserContext);

  const initializeData = useCallback(async () => {
    try {
      setLoading(true);
      const data = await getFaq(locale);
      setFaqItems(data);
      setError(null);
    } catch (e) {
      setError(e.message);
    } finally {
      setLoading(false);
    }
  }, [locale]);

  useEffect(() => {
    initializeData();
  }, [initializeData]);

  const value = {
    faqItems,
    loading,
    error,
    reinitialize: initializeData,
  };

  return <FaqContext.Provider value={value} {...props} />;
};

export { FaqContextProvider, FaqContext };
